import * as React from "react";
const SvgActiveIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 7, viewBox: "0 0 6 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 3, cy: 3.5, r: 3, fill: "#04C426" }));
export default SvgActiveIcon;
